import getErrorCardTitle from './getErrorCardTitle';
import { ErrorCardField } from './types';

/**
 * A field of an error with the item it is on - "Item 71 · Additional Document 1 · Document Identifier" -
 * for wherever the field is shown away from its card's title, so it names the item the way the card does.
 */
const formatErrorField = (field: ErrorCardField) => `${getErrorCardTitle([field])} · ${field.label}`;

export default formatErrorField;
